import { render, staticRenderFns } from "./sendDocumentOnMail.vue?vue&type=template&id=2d3149bc&scoped=true"
import script from "./sendDocumentOnMail.vue?vue&type=script&lang=js"
export * from "./sendDocumentOnMail.vue?vue&type=script&lang=js"
import style1 from "./sendDocumentOnMail.vue?vue&type=style&index=1&id=2d3149bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3149bc",
  null
  
)

export default component.exports